export default __webpack_public_path__ + "static/the-times-5c01fffa338521d9ca96d97d8a2ca9ec.svg";